import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Drawer, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

function AlertHeaderCell({ children }) {
  return (
    <Typography sx={{ fontWeight: 600, padding: "12px 10px", fontSize: 14 }}>
      {children}
    </Typography>
  );
}

AlertHeaderCell.propTypes = {
  children: PropTypes.node.isRequired,
};

function AlertColumn({ alerts }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      padding="12px 10px"
    >
      {alerts.slice(0, -1).map((alert) => (
        <React.Fragment key={alert}>
          <Typography sx={{ fontSize: 14 }}>{alert}</Typography>
          <Typography sx={{ fontSize: 14 }}>OR</Typography>
        </React.Fragment>
      ))}
      {alerts.length > 0 && (
        <Typography key={alerts.at(-1)} sx={{ fontSize: 14 }}>
          {alerts.at(-1)}
        </Typography>
      )}
    </Box>
  );
}

AlertColumn.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.string).isRequired,
};

function AlertRules({ alertRules, isOpen, handleAlertRules }) {
  return (
    <Drawer anchor="right" open={isOpen} onClose={handleAlertRules}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 16px",
          borderBottom: "1px solid #0000003B",
        }}
      >
        <Typography sx={{ fontSize: 20, fontWeight: 700 }}>
          Alert Rules
        </Typography>
        <Button onClick={handleAlertRules}>
          <CloseIcon sx={{ fontSize: 24, color: "#000" }} />
        </Button>
      </Box>

      <Box
        sx={{
          width: 600,
          padding: 2,
          display: "flex",
          flexDirection: "column",
          gap: 1.25,
        }}
      >
        <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
          {alertRules.title}
        </Typography>

        <Box sx={{ border: "1px solid #E0E0E0", borderRadius: 1 }}>
          <Box display="grid" gridTemplateColumns="0.7fr 1fr 1fr">
            <AlertHeaderCell>Vital Sign</AlertHeaderCell>
            <AlertHeaderCell>Yellow Alert</AlertHeaderCell>
            <AlertHeaderCell>Red Alert</AlertHeaderCell>
          </Box>

          {alertRules.measure.map(({ type, yellowAlert, redAlert }) => (
            <Box
              key={type}
              display="grid"
              gridTemplateColumns="0.7fr 1fr 1fr"
              sx={{ borderTop: "1px solid #E0E0E0" }}
            >
              <Box display="flex" alignItems="center" padding="12px 10px">
                <Typography sx={{ fontSize: 14 }}>{type}</Typography>
              </Box>
              <AlertColumn alerts={yellowAlert} />
              <AlertColumn alerts={redAlert} />
            </Box>
          ))}
        </Box>
      </Box>
    </Drawer>
  );
}

AlertRules.propTypes = {
  alertRules: PropTypes.shape({
    title: PropTypes.string,
    measure: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        yellowAlert: PropTypes.arrayOf(PropTypes.string).isRequired,
        redAlert: PropTypes.arrayOf(PropTypes.string).isRequired,
      })
    ),
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleAlertRules: PropTypes.func.isRequired,
};

export default AlertRules;
